import(/* webpackMode: "eager" */ "/home/ext_sax01_pam/builds/AmxgYjbu2/0/sax/portal/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ProfileContextProvider"] */ "/home/ext_sax01_pam/builds/AmxgYjbu2/0/sax/portal/src/app/_context/ProfileContext/ProfileContextProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/ext_sax01_pam/builds/AmxgYjbu2/0/sax/portal/src/app/_widgets/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivechatWidget"] */ "/home/ext_sax01_pam/builds/AmxgYjbu2/0/sax/portal/src/app/_widgets/LivechatWidget/LivechatWidget.tsx");
